export const membresias = [
  {
    sigla: "ADOMPRETUR",
    nombre: "Asociación Dominicana de Prensa Turística",
    href: "https://adompretur.com/",
    logo: `${import.meta.env.BASE_URL}afiliaciones/adompretur.webp`,
  },
  {
    sigla: "OMPT",
    nombre: "Organización Mundial de Periodismo Turístico",
    href: "https://www.periodismoturistico.org/",
    logo: `${import.meta.env.BASE_URL}afiliaciones/ompt.webp`,
  },
];
